import type { ParameterShape } from '@/core/utils/mappers/formatTypeUsage/types'

export const collectAssemblyNamesFromParameterShape = (shape: ParameterShape, assemblyNames: Set<string>): void => {
  switch (shape.kind) {
    case 'primitive': {
      const assemblyName = shape.assemblyName?.trim()
      if (assemblyName) {
        assemblyNames.add(assemblyName)
      }
      return
    }
    case 'array':
      collectAssemblyNamesFromParameterShape(shape.element, assemblyNames)
      return
    case 'generic':
      for (const arg of shape.args) {
        collectAssemblyNamesFromParameterShape(arg, assemblyNames)
      }
      return
    default:
      return
  }
}
